import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';

import { isArray, isNumber } from 'lodash';

const MappingTree = ({ originalMappingObjects, userMappingObjects, setTargetFocus, setShowMappingModal }) => {
  const [treeCheckedKeys, setTreeCheckedKeys] = useState({ checked: [], halfChecked: [] });
  const [treeMappedObjects, setTreeMappedObjects] = useState([]);
  const [treeCheckedKeysWithFieldNames, setTreeCheckedKeysWithFieldNames] = useState([]);

  useEffect(() => {
    updateTree();
  }, [originalMappingObjects, userMappingObjects]);

  const updateTree = () => {
    const checked = [];
    const newTreeCheckedKeysWithFieldNames = [];

    userMappingObjects.forEach((x) => {
      if (x) {
        const result = mapUserMappingToTreeCheckedKeys(x);

        if (result) {
          checked.push(result);
          newTreeCheckedKeysWithFieldNames.push({ formFieldName: x.formFieldName, treeKey: result });
        }
      }
    });

    setTreeCheckedKeysWithFieldNames(newTreeCheckedKeysWithFieldNames);

    const treeObjects = mapObjectToTreeObject(originalMappingObjects, checked);

    const halfChecked = getHalfCheckedTreeNodes(treeObjects, checked);

    setTreeCheckedKeys({ checked, halfChecked });
    setTreeMappedObjects(treeObjects);
  };

  const getAllUserNumbers = (key, checked) => {
    let userNumbers = [];

    checked?.forEach((x) => {
      if (x?.includes(key)) {
        let number = x.substring(key.length);
        number = number.substring(0, number.indexOf(']'));

        if (isNumber(+number) && !userNumbers.includes(+number)) {
          userNumbers.push(+number);
        }
      }
    });

    return userNumbers.sort();
  };

  const getHalfCheckedTreeNodes = (treeObjects, checked) => {
    const halfChecked = [];

    checkHalfCheckedTreeNodes(treeObjects, checked, halfChecked);

    return halfChecked;
  };

  const checkHalfCheckedTreeNodes = (treeObjects, checked, halfChecked, parentTreeKey) => {
    let isAllChecked = true;
    let isHalfChecked = false;

    treeObjects.map((element) => {
      if (element.children && element.children.length > 0) {
        const resChecked = checkHalfCheckedTreeNodes(element.children, checked, halfChecked, element.key);

        isAllChecked = isAllChecked && resChecked.isAllChecked;
        isHalfChecked = isHalfChecked || resChecked.isHalfChecked;
      } else {
        const isIncudes = checked.includes(element.key);

        isAllChecked = isAllChecked && isIncudes;
        isHalfChecked = isHalfChecked || isIncudes;
      }
    });

    if (isAllChecked && parentTreeKey) {
      checked.push(parentTreeKey);
    } else if (isHalfChecked && parentTreeKey) {
      halfChecked.push(parentTreeKey);
    }

    return { isAllChecked, isHalfChecked };
  };

  const mapUserMappingToTreeCheckedKeys = (element) => {
    let result;

    if (element) {
      result = element.objectKey;

      if (isNumber(element.objectPosition)) {
        result = result + '[' + element.objectPosition + ']';
      }

      if (element.childMapping) {
        result = result + '.' + mapUserMappingToTreeCheckedKeys(element.childMapping);
      }
    }

    return result;
  };

  const mapObjectToTreeObject = (parentElements, checked, prevKey) => {
    let resultObjects;

    if (isArray(parentElements)) {
      resultObjects = [];

      parentElements.forEach((element) => {
        let treeKey;

        if (prevKey) {
          treeKey = prevKey + '.' + element.objectKey;
        } else {
          treeKey = element.objectKey;
        }

        if (element.hasPosition) {
          let levels;
          const arrayChildren = [];

          levels = getAllUserNumbers(treeKey + '[', checked);

          if (!isArray(levels) || levels.length < 1) {
            levels = [0];
          }

          levels.forEach((x) => {
            let childMappings;
            let childTreeKey = treeKey + '[' + x + ']';

            if (isArray(element.childMappings)) {
              childMappings = mapObjectToTreeObject(element.childMappings, checked, childTreeKey);
            }

            arrayChildren.push({
              title: x,
              key: childTreeKey,
              children: childMappings,
              disableCheckbox: true,
            });
          });

          resultObjects.push({
            title: element.objectName,
            key: treeKey,
            children: arrayChildren,
            disableCheckbox: true,
          });
        } else {
          let childMapping;

          if (isArray(element.childMappings)) {
            childMapping = mapObjectToTreeObject(element.childMappings, checked, treeKey);
          }

          resultObjects.push({
            title: element.objectName,
            key: treeKey,
            children: childMapping,
            disableCheckbox: true,
          });
        }
      });
    }

    return resultObjects;
  };

  const onTreeSelect = (selectedKeys, { selected, selectedNodes, node, event }) => {
    const mappingWithName = treeCheckedKeysWithFieldNames.find((element) => element.treeKey == node.key);
    if (mappingWithName) {
      const fieldElement = document.getElementsByName(mappingWithName.formFieldName)[0];
      if (fieldElement) {
        setTargetFocus(fieldElement);
        setShowMappingModal(false);
      }
    }
  };

  return (
    <>
      <p>View the fields of objects that are already mapped, they are marked on the tree.</p>
      <p>Click on an already mapped object to see where this field on the PDF form.</p>
      <Tree checkable checkStrictly checkedKeys={treeCheckedKeys} treeData={treeMappedObjects} onSelect={onTreeSelect} />
    </>
  );
};

export default MappingTree;
